import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useIsRoute } from '@/hooks/useIsRoute'
import { PENDING_USER_ACTION } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'

export function useShouldRedirectToReviewAgreementTemplateRevisionsPage() {
  const currentUser = useCurrentUser()
  const pendingActions = currentUser?.pendingActions || []
  const isRoute = useIsRoute()

  const needsToReviewRevisedCommercialTerms = pendingActions.includes(
    PENDING_USER_ACTION.REVIEW_COMMERCIAL_AGREEMENT_TEMPLATE_REVISIONS,
  )
  return (
    needsToReviewRevisedCommercialTerms &&
    !isRoute(ROUTES._commercialAgreementTemplateRevisions) &&
    !isRoute(ROUTES._commercialAgreementTemplateReview)
  )
}
